/**
 * Tracking commun des menus mobiles du test A/B — un seul script pour les deux variantes.
 *   A : ancien tiroir Dawn (snippets/header-drawer.liquid), branché ici par initDrawerA().
 *   B : menu plein écran (assets/mobile-menu-v2.js), qui appelle window.MenuTracking.
 * La variante vient de window.impulseMenuVariant (posé par sections/header.liquid).
 *
 * Tout part dans le dataLayer en événement mobile_menu_interaction (relayé vers GA4 par GTM).
 * Écrit aussi l'attribut de panier menu_variant pour rattacher chaque commande à sa version.
 * Debug : ?menu_debug=1 affiche chaque envoi dans la console pour la session (?menu_debug=0 pour arrêter).
 */
(function () {
  if (window.MenuTracking) return;

  const DEBUG_KEY = 'impulse_menu_debug';
  const SEARCH_MIN_LENGTH = 3;
  const SEARCH_TERM_MAX_LENGTH = 50;
  // Actions qui valent validation de la recherche (plus d'abandon possible)
  const SEARCH_VALIDATION_ACTIONS = ['menu_search_submit', 'menu_search_result_click', 'menu_search_see_all'];

  const debug = (() => {
    const param = new URLSearchParams(window.location.search).get('menu_debug');
    try {
      if (param === '1') sessionStorage.setItem(DEBUG_KEY, '1');
      if (param === '0') sessionStorage.removeItem(DEBUG_KEY);
      return sessionStorage.getItem(DEBUG_KEY) === '1';
    } catch (e) {
      return param === '1';
    }
  })();

  function log(label, data) {
    if (!debug) return;
    console.log(`%c[menu ${getVariant()}] ${label}`, 'color:#fff;background:#1b232f;padding:1px 4px;border-radius:3px', data);
  }

  function getVariant() {
    if (window.impulseMenuVariant === 'A' || window.impulseMenuVariant === 'B') return window.impulseMenuVariant;
    return document.documentElement.classList.contains('menu-ab-b') ? 'B' : 'A';
  }

  // État de l'ouverture en cours : sert à menu_close (no_click / after_click) et à la recherche abandonnée
  const state = { open: false, clicked: false, search: null };

  /**
   * eventString : "action:détail". element (optionnel) : l'élément cliqué, pour déduire
   * la zone, le sous-bloc, le libellé, l'URL et la position. extra : paramètres forcés.
   */
  function track(eventString, element, extra = {}) {
    if (!eventString) return;
    const separator = eventString.indexOf(':');
    const action = separator === -1 ? eventString : eventString.slice(0, separator);
    const detail = separator === -1 ? '' : eventString.slice(separator + 1);

    const payload = {
      event: 'mobile_menu_interaction',
      menu_variant: getVariant(),
      menu_action: action,
      menu_detail: detail,
      menu_section: getSection(element),
      menu_group: '',
      menu_label: '',
      menu_url: '',
      menu_position: 0,
      menu_search_term: '',
    };

    if (element) {
      const group = element.closest('[data-ev-group]');
      payload.menu_group = group ? group.dataset.evGroup : '';
      payload.menu_label = (element.dataset.evLabel || element.getAttribute('aria-label') || element.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 100);
      const href = element.getAttribute('href');
      if (href) {
        try {
          const url = new URL(href, window.location.origin);
          payload.menu_url = url.origin === window.location.origin ? url.pathname : url.href;
        } catch (e) {
          payload.menu_url = href;
        }
      }
      payload.menu_position = parseInt(element.dataset.evPosition, 10) || getPosition(element);
      if (element.closest('.mobile-menu-v2__search') && state.search) {
        payload.menu_search_term = state.search.term;
      }
    }

    Object.assign(payload, extra);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    log(payload.menu_action, payload);
  }

  function getSection(element) {
    if (!element || !element.closest) return 'menu';
    const explicit = element.closest('[data-ev-section]');
    if (explicit) return explicit.dataset.evSection;
    const tabPanel = element.closest('[role="tabpanel"]');
    if (tabPanel) return tabPanel.id.replace(/^MMV2Panel-/, '').split('-')[0];
    if (element.closest('.mobile-menu-v2__search')) return 'recherche';
    if (element.closest('.mobile-menu-v2__footer')) return 'footer';
    if (element.closest('.mobile-menu-v2__tabs')) return 'onglets';
    if (element.closest('.mobile-menu-v2__topbar')) return 'topbar';
    return 'menu';
  }

  // Rang de l'élément parmi les éléments suivis de même niveau (repli si data-ev-position absent)
  function getPosition(element) {
    const parent = element.parentElement;
    if (!parent) return 0;
    const siblings = Array.from(parent.children).filter((child) => child.hasAttribute('data-ev'));
    const index = siblings.indexOf(element);
    return index === -1 ? 0 : index + 1;
  }

  // Suivi des clics [data-ev] d'un conteneur. Une seule écoute par conteneur, même si on rappelle la fonction.
  const boundRoots = new WeakSet();
  function bindClicks(root) {
    if (!root || boundRoots.has(root)) return;
    boundRoots.add(root);
    root.addEventListener('click', (event) => {
      const tracked = event.target.closest('[data-ev]');
      if (!tracked || !root.contains(tracked)) return;
      const action = tracked.dataset.ev.split(':')[0];
      if (SEARCH_VALIDATION_ACTIONS.includes(action)) searchValidated();
      // Seuls les liens, cartes et vignettes comptent comme un clic (pas les onglets ni les familles)
      if (state.open && tracked.tagName === 'A') state.clicked = true;
      track(tracked.dataset.ev, tracked);
    });
  }

  function menuOpened(detail = 'burger') {
    state.open = true;
    state.clicked = false;
    track(`menu_open:${detail}`);
  }

  // reason : croix, echap, clic_exterieur, retour
  function menuClosed(reason) {
    if (!state.open) return;
    searchEnded('fermeture_menu');
    track('menu_close', null, {
      menu_detail: state.clicked ? 'after_click' : 'no_click',
      menu_label: reason,
    });
    state.open = false;
    state.clicked = false;
  }

  function searchStarted() {
    state.search = { term: '', done: false };
  }

  function searchTyped(term) {
    if (!state.search) searchStarted();
    state.search.term = (term || '').trim();
  }

  function searchValidated() {
    if (state.search) state.search.done = true;
  }

  // reason : fermeture_recherche, fermeture_menu, sortie_page. Un seul envoi par recherche.
  function searchEnded(reason) {
    const search = state.search;
    state.search = null;
    if (!search || search.done || search.term.length < SEARCH_MIN_LENGTH) return;
    track('menu_search_abandon', null, {
      menu_section: 'recherche',
      menu_detail: reason,
      menu_search_term: search.term.slice(0, SEARCH_TERM_MAX_LENGTH),
    });
  }

  // Départ de la page menu ouvert sans clic : retour navigateur / Android (ou rechargement)
  window.addEventListener('pagehide', () => {
    if (!state.open) return;
    searchEnded('sortie_page');
    if (!state.clicked) menuClosed('retour');
  });

  /* ─── Variante A : ancien tiroir Dawn ─── */

  function initDrawerA() {
    if (getVariant() !== 'A') return;
    document.querySelectorAll('header-drawer').forEach((drawer) => {
      if (drawer.dataset.evBound) return;
      drawer.dataset.evBound = 'true';

      const main = drawer.querySelector('details.menu-drawer-container');
      const summary = main?.querySelector(':scope > summary');
      if (!main || !summary) return;
      let closeIntent = null;
      const setIntent = (reason) => {
        closeIntent = { reason, at: Date.now() };
      };

      // Ouverture / fermeture : on observe l'attribut open, retiré par Dawn après l'animation de fermeture
      new MutationObserver(() => {
        if (main.open && !state.open) {
          menuOpened();
        } else if (!main.open && state.open) {
          const recent = closeIntent && Date.now() - closeIntent.at < 2000;
          menuClosed(recent ? closeIntent.reason : 'autre');
          closeIntent = null;
        }
      }).observe(main, { attributes: true, attributeFilter: ['open'] });

      // Clic sur le summary menu ouvert : l'icône = croix, le reste (overlay ::before) = clic à l'extérieur.
      // L'icône × est positionnée hors du span du burger : on teste les deux zones.
      summary.addEventListener('click', (event) => {
        if (!main.open) return;
        const zones = [summary.querySelector(':scope > span'), summary.querySelector('.icon-close')]
          .filter(Boolean)
          .map((el) => el.getBoundingClientRect());
        const onIcon =
          event.detail === 0 ||
          zones.some(
            (rect) =>
              event.clientX >= rect.left - 12 && event.clientX <= rect.right + 12 &&
              event.clientY >= rect.top - 12 && event.clientY <= rect.bottom + 12
          );
        setIntent(onIcon ? 'croix' : 'clic_exterieur');
      });

      drawer.addEventListener('keyup', (event) => {
        if (event.code?.toUpperCase() !== 'ESCAPE') return;
        // Échap dans un sous-menu ne ferme que le sous-menu
        if (event.target.closest('details[open]') === main) setIntent('echap');
      });

      // Ouverture d'un sous-menu (équivalent de l'accordéon de B). L'événement toggle ne remonte pas.
      main.querySelectorAll('details[data-ev-family]').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open || !main.open) return;
          track(`menu_accordion_open:${details.dataset.evFamily}`, details.querySelector('summary'), {
            menu_label: details.dataset.evFamilyLabel || '',
            menu_position: parseInt(details.dataset.evFamilyPosition, 10) || 0,
          });
        });
      });

      // Bouton « ‹ retour » des sous-menus : ne ferme pas le menu, pas de menu_close
      main.querySelectorAll('.menu-drawer__close-button').forEach((button) => {
        button.addEventListener('click', () => {
          const details = button.closest('details[data-ev-family]');
          track(`menu_submenu_back:${details?.dataset.evFamily || ''}`, button, {
            menu_label: details?.dataset.evFamilyLabel || '',
          });
        });
      });

      bindClicks(main);
    });
  }

  /* ─── Attribut de panier menu_variant ─── */

  const cartState = {
    attribute: window.impulseMenuCart?.attribute ?? null,
    itemCount: window.impulseMenuCart?.itemCount ?? 0,
    pending: false,
  };
  const cartUpdateUrl = `${window.routes?.cart_update_url || '/cart/update'}.js`;

  // Écrit l'attribut seulement s'il y a au moins un article et que la valeur diffère
  function syncCart(cart) {
    if (cart && typeof cart.item_count === 'number') {
      cartState.itemCount = cart.item_count;
      cartState.attribute = cart.attributes?.menu_variant ?? null;
    }
    const variant = getVariant();
    if (!cartState.itemCount || cartState.attribute === variant || cartState.pending) return;

    cartState.pending = true;
    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { menu_variant: variant } }),
      keepalive: true,
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error(`HTTP ${response.status}`))))
      .then((updated) => {
        cartState.attribute = updated.attributes?.menu_variant ?? null;
        cartState.itemCount = updated.item_count;
        log('cart_attribute', { menu_variant: cartState.attribute, item_count: cartState.itemCount });
      })
      .catch((error) => log('cart_attribute_error', error.message))
      .finally(() => {
        cartState.pending = false;
      });
  }

  // Relit le panier (ajouts faits par des apps : Kite, upsell, quick add) puis synchronise
  let refreshTimer;
  function refreshCart() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => cart && syncCart(cart))
        .catch(() => {});
    }, 300);
  }

  function initCartSync() {
    syncCart();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
    }

    // Ouverture et mise à jour du panier tiroir : cartData est le panier complet quand il est fourni
    ['cart-drawer:opened', 'cart-drawer:update'].forEach((eventName) => {
      document.addEventListener(eventName, (event) => {
        const cart = event.detail?.cartData;
        if (cart && typeof cart.item_count === 'number') {
          syncCart(cart);
        } else {
          refreshCart();
        }
      });
    });

    if (document.querySelector('form#cart')) refreshCart();

    // Bouton de commande : l'attribut part avec le formulaire du panier, sans attendre de requête
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[name="checkout"]');
        const form = button?.form;
        if (!form) return;
        let input = form.querySelector('input[name="attributes[menu_variant]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'attributes[menu_variant]';
          form.appendChild(input);
        }
        input.value = getVariant();
        log('checkout_attribute', { menu_variant: input.value, form: form.id });
      },
      true
    );
  }

  window.MenuTracking = {
    track,
    bindClicks,
    menuOpened,
    menuClosed,
    searchStarted,
    searchTyped,
    searchValidated,
    searchEnded,
    getVariant,
    debug,
  };

  const init = () => {
    initDrawerA();
    initCartSync();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
